<h1 mat-dialog-title>Úprava cookies</h1>

<div mat-dialog-content
     class="cookies-edit">

  <h5>Cookies nevyhnutné na fungovanie webu</h5>

  <p>Nemožno zakázať.</p>

  <h5>Analytické cookies</h5>

  <p>Analytické cookies na našom webe sú zhromažďované skriptom spoločnosti Google Inc., ktorá následne tieto dáta anonymizuje. Po anonymizácii už nejde o
    osobné
    údaje, pretože anonymizované cookies nie je možné priradiť konkrétnemu používateľovi, resp. konkrétnej osobe. My pracujeme iba s cookies v anonymizovanej
    podobe. Preto nedokážeme z cookies zistiť, ako sa konkrétny používateľ na našom webe správal (aké stránky navštívil, aký tovar si prezeral a pod.)</p>

  <mat-radio-group [(ngModel)]="googleAnalytics"
                   aria-label="Select an option">
    <mat-radio-button [value]="typeOfApprovalType.AGREE">Súhlasím</mat-radio-button>
    <mat-radio-button checked [value]="typeOfApprovalType.DISAGREE">Nesúhlasím</mat-radio-button>
  </mat-radio-group>

  <h5>Personalizovaná reklama</h5>

  <p>Personalizovaná reklama</p>

  <mat-radio-group [(ngModel)]="googleAds"
                   aria-label="Select an option">
    <mat-radio-button [value]="typeOfApprovalType.AGREE">Súhlasím</mat-radio-button>
    <mat-radio-button checked [value]="typeOfApprovalType.DISAGREE">Nesúhlasím</mat-radio-button>
  </mat-radio-group>

</div>

<div mat-dialog-actions>

  <button mat-button
          (click)="saveCookies()">Uložiť
  </button>
  <button mat-button
          (click)="close(false)">Zatvoriť
  </button>

</div>
